import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import { AppIcon } from '../icons/';
import { Button } from '../buttons';
import { BOTTOM_ROW_HEIGHT_REM, SPACE_AROUND_IN_CALL_MODAL_REM } from '../../util/constants';
export const TrayLayout = ({ isOpen, onToggleClick, toggleText, stageContent, trayContent, toolbarCentralContent, toolbarRightContent, testId, }) => {
    return (_jsxs(Wrapper, { "data-testid": testId, children: [_jsxs(TopRow, { children: [_jsx(SideBarOuterWrapper, { isOpen: isOpen, children: _jsx(SideBarInnerWrapper, { isOpen: isOpen, children: trayContent }) }), _jsx(StageWrapper, { children: stageContent })] }), _jsxs(BottomRow, { children: [_jsx(ToolbarWrapper, { children: _jsxs(SideBarButton, { isOpen: isOpen, onClick: onToggleClick, variant: "tertiary", "aria-label": `Toggle ${toggleText}`, "data-testid": "tray-toggle-button", children: [toggleText, _jsx(SideBarButtonDecorator, { isopen: isOpen ? 'true' : null, name: "CaretIcon" })] }) }), _jsx(CenterToolbarWrapper, { children: toolbarCentralContent }), _jsx(ToolbarWrapper, { children: toolbarRightContent })] })] }));
};
const Wrapper = styled.div(({ theme }) => {
    return {
        backgroundColor: theme.colors.white,
        width: `calc(100vw - ${2 * SPACE_AROUND_IN_CALL_MODAL_REM}px)`,
        height: `calc(100vh - ${2 * SPACE_AROUND_IN_CALL_MODAL_REM}px)`,
        display: 'grid',
        gridTemplateRows: `calc(100vh - ${2 * SPACE_AROUND_IN_CALL_MODAL_REM + BOTTOM_ROW_HEIGHT_REM}rem) ${BOTTOM_ROW_HEIGHT_REM}rem`,
    };
});
const SideBarOuterWrapper = styled.div(({ isOpen, theme }) => ({
    overflowY: 'auto',
    overflowX: 'hidden',
    width: `${isOpen ? '450' : '0'}px`,
    transition: 'width 150ms ease-out',
    backgroundColor: theme.colors.white,
    zIndex: 1,
    position: 'relative',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        width: `${isOpen ? '400' : '0'}px`,
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        width: `${isOpen ? '100vw' : '0px'}`,
        height: `${isOpen ? '450' : '0'}px`,
        transition: 'height 150ms ease-out',
        zIndex: isOpen ? 1 : 0,
        position: 'absolute',
        bottom: '0',
    },
}));
const SideBarInnerWrapper = styled.div(({ isOpen, theme }) => ({
    width: '450px',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        width: '400px',
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        width: '100vw',
        height: `${isOpen ? '450' : '0'}px`,
        transition: 'height 150ms ease-out',
    },
}));
const TopRow = styled.div(({ theme }) => ({
    position: 'relative',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: `max-content auto`,
    transition: 'all 150ms ease-in',
    zIndex: 1,
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        display: 'block',
    },
}));
const StageWrapper = styled.div(({ theme }) => ({
    position: 'relative',
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        height: '100%',
    },
}));
const BottomRow = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    transition: 'all 150ms ease-in',
    backgroundColor: theme.colors.grey05,
    zIndex: 2,
    [`@media ${theme.mediaBreakpoints.small}`]: {
        gridTemplateColumns: '400px auto auto',
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        gridTemplateColumns: '100% 0px 0px',
        position: 'fixed',
        bottom: '0',
        height: `${BOTTOM_ROW_HEIGHT_REM}rem`,
    },
}));
const SideBarButton = styled(Button)(({ isOpen, theme }) => ({
    position: 'relative',
    overflow: 'visible',
    height: '100%',
    zIndex: 1,
    backgroundColor: theme.colors.white,
    borderRadius: `0px ${isOpen ? '0' : '30px'} 30px 0px`,
    color: theme.colors.grey90,
    width: `${isOpen ? '450px' : '215px'}`,
    padding: '0 32px',
    transition: 'all 150ms ease-out',
    ':hover, :active, :focus': {
        backgroundColor: theme.colors.white,
        color: theme.colors.azure,
        textDecoration: 'none',
        borderRadius: `0px ${isOpen ? '0' : '30px'} 30px  0px`,
        [`@media ${theme.mediaBreakpoints.xsmall}`]: {
            borderRadius: '0px',
        },
    },
    ':hover svg, :active svg, :focus svg': {
        backgroundColor: theme.colors.white,
        color: theme.colors.azure,
    },
    ':hover svg path, :active svg path, :focus svg path': {
        fill: theme.colors.azure,
    },
    span: {
        justifyContent: 'flex-end',
        marginRight: '16px',
        [`@media ${theme.mediaBreakpoints.xsmall}`]: {
            justifyContent: 'flex-start',
        },
    },
    [`@media ${theme.mediaBreakpoints.small}`]: {
        width: `${isOpen ? '400px' : '215px'}`,
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        width: '100vw',
        borderRadius: '0px',
    },
}));
// isopen is lowercased and of type string, otherwise it will get passed to the dom due to prop spreading to the AppIcon
// and cause a react warning in the console
const SideBarButtonDecorator = styled(AppIcon)(({ isopen, theme }) => ({
    position: 'absolute',
    backgroundColor: theme.colors.white,
    right: '10px',
    opacity: 1,
    borderRadius: '50%',
    transform: `scale(1.2) rotate(${isopen ? '90deg' : '-90deg'}) !important`,
    transition: 'all 150ms ease-out',
    padding: '0 3px',
    '& path': {
        transition: 'fill 150ms ease-in',
        fill: theme.colors.azure,
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        transform: `scale(1.2) rotate(${isopen ? '0deg' : '180deg'}) !important`,
        position: 'relative',
        marginLeft: '6px',
        right: '0',
    },
}));
const ToolbarWrapper = styled.div({
    display: 'flex',
    height: '100%',
    width: '100%',
});
const CenterToolbarWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    height: '100%',
    width: '100%',
    [`@media ${theme.mediaBreakpoints.small}`]: {
        justifyContent: 'center',
    },
    [`@media ${theme.mediaBreakpoints.xsmall}`]: {
        display: 'none',
    },
}));
//# sourceMappingURL=trayLayout.js.map